/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import axios from 'axios';
import { Maybe } from 'purify-ts';
import { FeedbackReply } from '@/models/feedback';
import { AssignmentsStore, SubmissionsStore } from '@/store';
import * as utils from '@/utils';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export class CommentNotification {
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    constructor(id, type, commentReply, submissionId, assignmentId, createdAt, read, fileId, reasons) {
        this.id = id;
        this.type = type;
        this.commentReply = commentReply;
        this.submissionId = submissionId;
        this.assignmentId = assignmentId;
        this.createdAt = createdAt;
        this.read = read;
        this.fileId = fileId;
        this.reasons = reasons;
        Object.freeze(this.reasons);
        Object.freeze(this);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    static fromServerData(data) {
        const reply = FeedbackReply.fromServerData(data.comment_reply, data.comment_base_id);
        return new CommentNotification(data.id, data.type, reply, data.work_id, data.assignment_id, utils.toMoment(data.created_at), data.read, Maybe.fromNullable(data.file_id).map(utils.coerceToString), data.reasons);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    async markAsRead() {
        const response = await axios.patch(`/api/v1/notifications/${this.id}`, {
            read: true,
        });
        return {
            ...response,
            cgResult: CommentNotification.fromServerData(response.data),
        };
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    get assignment() {
        return AssignmentsStore.getAssignment()(this.assignmentId);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    get submission() {
        return SubmissionsStore.getSingleSubmission()(this.submissionId);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    get focusId() {
        return this.commentReply.focusId;
    }
}
